import { createSelector } from 'reselect'

import { selectFinancialCockpitState } from './selectFinancialCockpitState'

export const selectIsCockpitPartnerDetailsVisible = createSelector(
  [selectFinancialCockpitState],
  ({ isPartnerDetailsVisible }) => isPartnerDetailsVisible
)
